export default "__VITE_ASSET__DocMMCfP__"